<template>
    <v-dialog
        :value="isOpen"
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="!isNewCustomerContact">
                        Edycja kontaktu
                    </template>
                    <template v-else>
                        Nowy kontakt
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-text-field
                    v-model="customerContact.firstName"
                    label="Imię"
                    outlined
                    dense
                    :error-messages="firstNameErrors"
                    required
                />
                <v-text-field
                    v-model="customerContact.lastName"
                    label="Nazwisko"
                    outlined
                    dense
                    :error-messages="lastNameErrors"
                    required
                />
                <v-text-field
                    v-model="customerContact.phoneNumber"
                    v-mask="'(+##) #########'"
                    label="Numer telefonu"
                    outlined
                    dense
                    :error-messages="phoneNumberErrors"
                    required
                />
                <v-text-field
                    v-model="customerContact.email"
                    label="Email"
                    outlined
                    dense
                    :error-messages="emailErrors"
                    required
                />
                <v-text-field
                    v-model="customerContact.contactWorkplace"
                    label="Uwagi"
                    outlined
                    dense
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="saveCustomerContact()"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { isEmpty } from 'lodash'

export default {
    name: 'CustomerContactDialog',
    directives: { mask },
    props: {
        isOpen: {
            type: Boolean
        },
        customerContactData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            actionLoading: false,
            customerContact: {
                firstName: null,
                lastName: null,
                phoneNumber: null,
                email: null,
                contactWorkplace: null,
                addresses: []
            },
        }
    },
    validations() {
        return {
            customerContact: {
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                phoneNumber: {
                    required
                },
                email: {
                    required,
                    email
                },
            }
        }
    },
    computed: {
        isNewCustomerContact() {
            return isEmpty(this.customerContactData)
        },
        firstNameErrors() {
            const errors = []

            if (!this.$v.customerContact.firstName.$dirty) return errors
            !this.$v.customerContact.firstName.required && errors.push('Proszę podać imię.')

            return errors
        },
        lastNameErrors() {
            const errors = []

            if (!this.$v.customerContact.lastName.$dirty) return errors
            !this.$v.customerContact.lastName.required && errors.push('Proszę podać nazwisko.')

            return errors
        },
        phoneNumberErrors() {
            const errors = []

            if (!this.$v.customerContact.phoneNumber.$dirty) return errors
            !this.$v.customerContact.phoneNumber.required && errors.push('Proszę podać numer telefonu.')

            return errors
        },
        emailErrors() {
            const errors = []

            if (!this.$v.customerContact.email.$dirty) return errors
            !this.$v.customerContact.email.required && errors.push('Proszę podać adres email.')
            if (!this.$v.customerContact.email.email) {
                errors.push('Proszę podać poprawny format dla adresu email.')
            }

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean && !this.isNewCustomerContact) {
                this.customerContact = JSON.parse(JSON.stringify(this.customerContactData))
            }
        },
    },
    methods: {
        saveCustomerContact() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.actionLoading = true
            this.$emit('on-confirm', this.customerContact)
            this.onClose()
        },
        onClose() {
            this.actionLoading = false
            this.$emit('on-close')
            this.$v.$reset()
            setTimeout(() => {
                this.customerContact = {
                    firstName: null,
                    lastName: null,
                    phoneNumber: null,
                    email: null,
                    contactWorkplace: null,
                    addresses: []
                }
            }, 500)
        },
    }
}
</script>

